import { useSelector } from "react-redux";
import Configuracao from "./Configuracao";
import UsuarioPerfilTable from "../../Usuario/UsuarioPerfilTable";
import AlunoResponsavelAtivoTable from "../../AlunoResponsavel/AlunoResponsavelAtivoTable";
import UsuarioInstituicaoTable from "../../UsuarioInstituicao/UsuarioInstituicaoTable";
import SystemColors from "./SystemColors";
import { ADMIN } from "../../Usuario/Perfil";
import { Grid, Typography } from "@mui/material";
import CredentialK8PayContainer from "../../CredentialK8Pay/CredentialK8PayContainer";
import UsuarioCartaoCreditoContainer from "../../UsuarioCartaoCredito/UsuarioCartaoCreditoContainer";
import GridPaper from "../../../util/GridPaper";

const ConfiguracaoInstituicaoContainer = () => {
  const usuario = useSelector((state) => state.usuario);
  return (
    <Grid container spacing={4} direction="column">
      <Grid>
        <Configuracao />
      </Grid>
      <Grid size={12}>
        <Grid container direction='row' spacing={5}>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <Typography variant='h5'>Meus Cartões</Typography>
              </Grid>
              <GridPaper>
                <UsuarioCartaoCreditoContainer />
              </GridPaper>
            </Grid>

          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}>
            <UsuarioPerfilTable />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
      </Grid>
      <Grid size={12}>
        <Grid container direction='row' spacing={5}>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}>
            <AlunoResponsavelAtivoTable />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6
            }}>
            <UsuarioInstituicaoTable />
          </Grid>
        </Grid>
      </Grid>
      {
        usuario && usuario.perfil === ADMIN &&
        <Grid size={12}>
          <Grid container direction='row' spacing={5}>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              <SystemColors />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              <CredentialK8PayContainer />
            </Grid>
          </Grid>
        </Grid>

      }
    </Grid >
  );
};

export default ConfiguracaoInstituicaoContainer;
